// We don't want the attachment functionality of the trix editor.
// Therefore we remove the attachment-button and anything related with the attachment functionality.

up.on(document, 'trix-initialize', function(event) {
  const toolbarElement = event.target.toolbarElement
  const disallowedActions = ['attachFiles']

  // Remove attachment button
  toolbarElement.querySelectorAll('.trix-button--icon').forEach(button => {
    const action = button.getAttribute('data-trix-action')
    if (disallowedActions.includes(action)) {
      button.parentNode.remove()
    }
  })
})

// Prevents any type of file accepting (e.g. via button or dragging the file into the editor)
// (https://github.com/basecamp/trix#storing-attached-files)
up.on(document, 'trix-file-accept', function(event) {
  event.preventDefault()
})
